import MovieDetailUI from './MovieDetailUI'
export default MovieDetailUI